import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

const OptionTitle = ({ children }) => {
  return (
    <h5 className="uni-select__title">
      {children}
    </h5>
  );
};

OptionTitle.propTypes = {
  children: PropTypes.node,
};

export default OptionTitle;



// WEBPACK FOOTER //
// ./src/selects/option-title/index.jsx